import type { ReactNode } from 'react';
import { Scale } from 'lucide-react';
import { isMarketingOnlyDomain, MarketingFooter, MarketingHeader } from '@/modules/marketing/components/site-chrome';
import { cn } from '@/lib/utils';

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
    return (
        <section className="scroll-mt-24">
            <h2 className="text-lg font-bold tracking-tight text-foreground">{title}</h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground [&_a]:font-medium [&_a]:text-primary [&_a]:hover:underline [&_li]:ml-5 [&_li]:list-disc [&_strong]:text-foreground">
                {children}
            </div>
        </section>
    );
}

export function LegalPageLayout({ title, lastUpdated, children }: { title: string; lastUpdated: string; children: ReactNode }) {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <MarketingHeader />

            <section
                className={cn(
                    'border-b bg-gradient-to-br py-16 text-white',
                    isMarketingOnlyDomain() ? 'from-[#7f1d2e] to-[#e62b4a]' : 'from-[#1e3a5f] to-[#2563eb]',
                )}
            >
                <div className="mx-auto max-w-3xl px-6 text-center">
                    <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-white/15 backdrop-blur">
                        <Scale className="size-7" />
                    </div>
                    <h1 className="mt-5 text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h1>
                    <p className="mt-3 text-sm text-white/70">Last updated: {lastUpdated}</p>
                </div>
            </section>

            <section className="py-16">
                <div className="mx-auto max-w-3xl space-y-10 px-6">{children}</div>
            </section>

            <MarketingFooter />
        </div>
    );
}
